import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function manageProductReducer(state = initialState.manageProduct, action) {
	// avoiding state mutation, while updating nested states.
	switch (action.type) {
		case types.FETCH_MANAGE_PRODUCT_DATA:
			return action.data;
		default:
			return state;
	}
}
